import React, { useState, useEffect, useRef } from 'react'
import { Card, Collapse } from 'antd'
import { CaretRightOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
import {
  paginationInit,
  formatMessageNew,
  downLoadFileBlob,
  formatStartTime,
  formatEndTime,
  dateFormatYearMonthDay,
  initDateFormat,
  initValueAndLabel,
  uniqueFun,
  isChineseFun
} from '@/utils/common'
import {
  exportAccuracyDetailPage,
  getAccuracyDetailQuery,
  getAccuracyDetailDroplist
} from '@/services/rfid/reports/operationAccuracyDetail'
import AntdTable from '@/components/table/AntdTable'
import SearchBar from '@/components/searchbar/SearchBar'
import { RETAG_LIST2 } from '@/utils/types'
const startMonth = dayjs().subtract(1, 'day')
const endMonth = dayjs().subtract(1, 'day')

const OperationAccuracyDetail = () => {
  const [tableList, setTableList] = useState([])
  const [queryFlag, setQueryFlag] = useState(false)
  const [pagination, setPagination] = useState(paginationInit)
  const mounting = useRef(false)
  const [iBValuesChangeFlag, setIBValuesChangeFlag] = useState(false)
  const [oBValuesChangeFlag, setOBValuesChangeFlag] = useState(false)
  let formRef = useRef(null)
  let formRefIB = useRef(null)
  let formRefOB = useRef(null)
  const tableColumns = [
    {
      title: formatMessageNew('languageObj.operationAccuracyDetail.rfid'),
      dataIndex: 'epc',
      fixed: 'left',
      width: 240,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.operationAccuracyDetail.productCode'),
      dataIndex: 'productCode',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.operationAccuracyDetail.size'),
      dataIndex: 'productSize',
      width: 80,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.operationAccuracyDetail.upc'),
      dataIndex: 'upc',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.operationAccuracyDetail.productName'),
      dataIndex: 'productName',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.operationAccuracyDetail.purchaseOrder'),
      dataIndex: 'poNumber',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },

    {
      title: formatMessageNew('languageObj.operationAccuracyDetail.IB'),
      dataIndex: 'IB',
      children: [
        {
          title:
            formatMessageNew('languageObj.operationAccuracyDetail.IBTitle') +
            formatMessageNew('languageObj.operationAccuracyDetail.IBCartonNumber'),
          dataIndex: 'ibLabelNo',
          width: 150,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.operationAccuracyDetail.IBTitle') +
            formatMessageNew('languageObj.operationAccuracyDetail.IBOriginalCartonNumber'),
          dataIndex: 'ibActualCartonNo',
          width: 180,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title: formatMessageNew('languageObj.operationAccuracyDetail.IBASN'),
          dataIndex: 'asnNumber',
          width: 120,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title: formatMessageNew('languageObj.operationAccuracyDetail.multipleASNNotice'),
          dataIndex: 'multipleASNNotice',
          width: 150,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.operationAccuracyDetail.IBTitle') +
            formatMessageNew('languageObj.operationAccuracyDetail.IBTunnelID'),
          dataIndex: 'ibDeviceCode',
          width: 120,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.operationAccuracyDetail.IBTitle') +
            formatMessageNew('languageObj.operationAccuracyDetail.IBLPNSizeType'),
          dataIndex: 'lpnSizeType',
          width: 180,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.operationAccuracyDetail.IBTitle') +
            formatMessageNew('languageObj.operationAccuracyDetail.IBFactoryCode'),
          dataIndex: 'factoryCode',
          width: 120,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.operationAccuracyDetail.IBTitle') +
            formatMessageNew('languageObj.operationAccuracyDetail.IBCarrier'),
          dataIndex: 'ibCarrier',
          width: 120,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.operationAccuracyDetail.IBTitle') +
            formatMessageNew('languageObj.operationAccuracyDetail.IBItemAttribute'),
          dataIndex: 'itemAttribute',
          width: 150,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title: formatMessageNew('languageObj.operationAccuracyDetail.IBGRDate'),
          dataIndex: 'grDate',
          width: 120,
          render: text => {
            return <div className="word_break_all">{initDateFormat(text)}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.operationAccuracyDetail.IBTitle') +
            formatMessageNew('languageObj.operationAccuracyDetail.IBScanDate'),
          dataIndex: 'ibScanTime',
          width: 120,
          render: text => {
            return <div className="word_break_all">{initDateFormat(text)}</div>
          }
        }
      ]
    },
    {
      title: formatMessageNew('languageObj.operationAccuracyDetail.OB'),
      dataIndex: 'OB',
      children: [
        {
          title:
            formatMessageNew('languageObj.operationAccuracyDetail.OBTitle') +
            formatMessageNew('languageObj.operationAccuracyDetail.OBCartonNumber'),
          dataIndex: 'obLabelNo',
          width: 150,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title: formatMessageNew('languageObj.operationAccuracyDetail.salesOrder'),
          dataIndex: 'salesOrder',
          width: 120,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title: formatMessageNew('languageObj.operationAccuracyDetail.OBDeliveryNoteNo'),
          dataIndex: 'deliveryNoteNo',
          width: 150,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title: formatMessageNew('languageObj.operationAccuracyDetail.multipleDNNotice'),
          dataIndex: 'multipleDnNotice',
          width: 150,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },

        {
          title:
            formatMessageNew('languageObj.operationAccuracyDetail.OBTitle') +
            formatMessageNew('languageObj.operationAccuracyDetail.OBMajor'),
          dataIndex: 'packlistNo',
          width: 120,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.operationAccuracyDetail.OBTitle') +
            formatMessageNew('languageObj.operationAccuracyDetail.OBTunnelID'),
          dataIndex: 'obDeviceCode',
          width: 120,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.operationAccuracyDetail.OBTitle') +
            formatMessageNew('languageObj.operationAccuracyDetail.OBTaskType'),
          dataIndex: 'taskType',
          width: 120,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.operationAccuracyDetail.OBTitle') +
            formatMessageNew('languageObj.operationAccuracyDetail.OBSOType'),
          dataIndex: 'salesOrderType',
          width: 120,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.operationAccuracyDetail.OBTitle') +
            formatMessageNew('languageObj.operationAccuracyDetail.OBCarrier'),
          dataIndex: 'obCarrier',
          width: 120,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.operationAccuracyDetail.OBTitle') +
            formatMessageNew('languageObj.operationAccuracyDetail.OBRetag'),
          dataIndex: 'reissueTag',
          width: 120,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.operationAccuracyDetail.OBTitle') +
            formatMessageNew('languageObj.operationAccuracyDetail.OBShipFrom'),
          dataIndex: 'shipFrom',
          width: 120,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.operationAccuracyDetail.OBTitle') +
            formatMessageNew('languageObj.operationAccuracyDetail.OBShipTo'),
          dataIndex: 'shipTo',
          width: 120,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.operationAccuracyDetail.OBTitle') +
            formatMessageNew('languageObj.operationAccuracyDetail.OBStore'),
          dataIndex: 'markFor',
          width: 120,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.operationAccuracyDetail.OBTitle') +
            formatMessageNew('languageObj.operationAccuracyDetail.OBItemAttribute'),
          dataIndex: 'obItemAttribute',
          width: 150,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.operationAccuracyDetail.OBTitle') +
            formatMessageNew('languageObj.operationAccuracyDetail.OBTrailerNumber'),
          dataIndex: 'trailerNumber',
          width: 150,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.operationAccuracyDetail.OBTitle') +
            formatMessageNew('languageObj.operationAccuracyDetail.OBCartonNetWeight'),
          dataIndex: 'netWeight',
          width: 150,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.operationAccuracyDetail.OBTitle') +
            formatMessageNew('languageObj.operationAccuracyDetail.OBCartonGrossWeight'),
          dataIndex: 'grossWeight',
          width: 180,
          render: text => {
            return <div className="word_break_all">{text}</div>
          }
        },
        {
          title: formatMessageNew('languageObj.operationAccuracyDetail.OBGIDate'),
          dataIndex: 'createDate',
          width: 120,
          render: text => {
            return <div className="word_break_all">{initDateFormat(text)}</div>
          }
        },
        {
          title:
            formatMessageNew('languageObj.operationAccuracyDetail.OBTitle') +
            formatMessageNew('languageObj.operationAccuracyDetail.OBScanDate'),
          dataIndex: 'obScanTime',
          width: 120,
          render: text => {
            return <div className="word_break_all">{initDateFormat(text)}</div>
          }
        }
      ]
    }
  ]

  let searchListInit = [
    {
      type: 'input',
      label: 'languageObj.operationAccuracyDetail.cartonNumber',
      key: 'labelNo',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.operationAccuracyDetail.productCode',
      key: 'productCode',
      allowClear: true,
      initialValues: null,
      // mode: 'multiple',
      // maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'timeRange',
      label: 'languageObj.operationAccuracyDetail.scanDate',
      key: 'scanDate',
      format: dateFormatYearMonthDay,
      disabledDate: current => {
        let falg = current && current > dayjs().endOf('day')
        return falg
      },
      initialValues: [startMonth, endMonth],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true',
      allowClear: false
    },
    {
      type: 'input',
      label: 'languageObj.operationAccuracyDetail.upc',
      key: 'upc',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'select',
      label: 'languageObj.operationAccuracyDetail.tunnelID',
      key: 'ibDeviceCode',
      allowClear: true,
      initialValues: null,
      // mode: 'multiple',
      // maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    },
    {
      type: 'input',
      label: 'languageObj.operationAccuracyDetail.rfid',
      key: 'epc',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      },
      isdefaultfilter: 'true'
    }
  ]
  const [searchList, setSearchList] = useState(searchListInit)
  let ibSearchListInit = [
    {
      type: 'input',
      label: 'languageObj.operationAccuracyDetail.purchaseOrder',
      key: 'poNumber',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.operationAccuracyDetail.IBASN',
      key: 'asnNumber',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'timeRange',
      label: 'languageObj.operationAccuracyDetail.IBGRDate',
      key: 'ibGrDate',
      format: dateFormatYearMonthDay,
      disabledDate: current => {
        let falg = current && current > dayjs().endOf('day')
        return falg
      },
      initialValues: [],
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'select',
      label: 'languageObj.operationAccuracyDetail.IBLPNSizeType',
      key: 'lpnSizeType',
      allowClear: true,
      initialValues: null,
      // mode: 'multiple',
      // maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'select',
      label: 'languageObj.operationAccuracyDetail.IBFactoryCode',
      key: 'factoryCode',
      allowClear: true,
      initialValues: null,
      // mode: 'multiple',
      // maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'select',
      label: 'languageObj.operationAccuracyDetail.IBCarrier',
      key: 'ibCarrier',
      allowClear: true,
      initialValues: null,
      // mode: 'multiple',
      // maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      }
    },

    {
      type: 'input',
      label: 'languageObj.operationAccuracyDetail.IBItemAttribute',
      key: 'itemAttribute',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.operationAccuracyDetail.IBOriginalCartonNumber',
      key: 'ibActualCartonNo',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.operationAccuracyDetail.multipleASNNotice',
      key: 'multipleAsnNotice',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    }
  ]
  const [ibSearchList, setIbSearchList] = useState(ibSearchListInit)
  const getInitialValues = (ls = []) => {
    let obj = {}
    ls.forEach(item => {
      obj[item.key] = item.initialValues
    })
    return obj
  }
  let obSearchListInit = [
    {
      type: 'input',
      label: 'languageObj.operationAccuracyDetail.salesOrder',
      key: 'salesOrder',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.operationAccuracyDetail.OBDeliveryNoteNo',
      key: 'deliveryNoteNo',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'timeRange',
      label: 'languageObj.operationAccuracyDetail.OBGIDate',
      key: 'obGiDate',
      format: dateFormatYearMonthDay,
      disabledDate: current => {
        let falg = current && current > dayjs().endOf('day')
        return falg
      },
      initialValues: [],
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'select',
      label: 'languageObj.operationAccuracyDetail.OBTaskType',
      key: 'taskType',
      allowClear: true,
      initialValues: null,
      // mode: 'multiple',
      // maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.operationAccuracyDetail.OBMajor',
      key: 'packlistNo',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'select',
      label: 'languageObj.operationAccuracyDetail.OBSOType',
      key: 'salesOrderType',
      allowClear: true,
      initialValues: null,
      // mode: 'multiple',
      // maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      }
    },

    {
      type: 'input',
      label: 'languageObj.operationAccuracyDetail.OBShipFrom',
      key: 'shipFrom',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.operationAccuracyDetail.OBShipTo',
      key: 'shipTo',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'select',
      label: 'languageObj.operationAccuracyDetail.OBRetag',
      key: 'reissueTag',
      allowClear: true,
      initialValues: null,
      // mode: 'multiple',
      // maxTagCount: 1,
      selectList: RETAG_LIST2,
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.operationAccuracyDetail.OBStore',
      key: 'markFor',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.operationAccuracyDetail.OBItemAttribute',
      key: 'obItemAttribute',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'select',
      label: 'languageObj.operationAccuracyDetail.OBCarrier',
      key: 'obCarrier',
      allowClear: true,
      initialValues: null,
      // mode: 'multiple',
      // maxTagCount: 1,
      selectList: [],
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.operationAccuracyDetail.OBTrailerNumber',
      key: 'trailerNumber',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.operationAccuracyDetail.multipleDNNotice',
      key: 'multipleDnNotice',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    }
  ]
  const [obSearchList, setObSearchList] = useState(obSearchListInit)
  useEffect(() => {
    searchSelectDropFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const searchSelectDropFun = () => {
    getAccuracyDetailDroplist().then(res => {
      let dt = res.resultData || []
      searchListInit.forEach(itemFirst => {
        if (itemFirst.key === 'productCode' || itemFirst.key === 'ibDeviceCode') {
          let arr = []
          if (itemFirst.key === 'productCode') {
            arr = (dt.find(item => item.type === '8') || {}).value || []
          }
          if (itemFirst.key === 'ibDeviceCode') {
            arr = (dt.find(item => item.type === '1') || {}).value || []
          }
          itemFirst.selectList = initValueAndLabel(uniqueFun(arr, 2))
        }
      })
      setSearchList([...searchListInit])
      ibSearchList.forEach(itemFirst => {
        if (itemFirst.key === 'ibCarrier' || itemFirst.key === 'factoryCode' || itemFirst.key === 'lpnSizeType') {
          let arr = []
          if (itemFirst.key === 'ibCarrier') {
            arr = (dt.find(item => item.type === '4') || {}).value || []
          }
          if (itemFirst.key === 'factoryCode') {
            arr = (dt.find(item => item.type === '3') || {}).value || []
          }
          if (itemFirst.key === 'lpnSizeType') {
            arr = (dt.find(item => item.type === '2') || {}).value || []
          }
          itemFirst.selectList = initValueAndLabel(uniqueFun(arr, 2))
        }
      })
      setIbSearchList([...ibSearchList])
      obSearchList.forEach(itemFirst => {
        if (itemFirst.key === 'obCarrier' || itemFirst.key === 'salesOrderType' || itemFirst.key === 'taskType') {
          let arr = []
          if (itemFirst.key === 'obCarrier') {
            arr = (dt.find(item => item.type === '7') || {}).value || []
          }
          if (itemFirst.key === 'salesOrderType') {
            arr = (dt.find(item => item.type === '6') || {}).value || []
          }
          if (itemFirst.key === 'taskType') {
            arr = (dt.find(item => item.type === '5') || {}).value || []
          }
          itemFirst.selectList = initValueAndLabel(uniqueFun(arr, 2))
        }
      })
      setObSearchList([...obSearchList])
    })
  }

  useEffect(() => {
    if (mounting.current) searchDataFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])
  const searchDataBtn = () => {
    mounting.current = true
    const pg = {
      ...pagination,
      currentPage: 1
    }
    setPagination(pg)
    setQueryFlag(!queryFlag)
  }
  const searchClearDataBtn = () => {
    formRef && formRef.current && formRef.current.clearForm()
    formRefIB && formRefIB.current && formRefIB.current.clearForm()
    formRefOB && formRefOB.current && formRefOB.current.clearForm()
    const pg = {
      ...pagination,
      currentPage: 1
    }
    setPagination(pg)
    setQueryFlag(!queryFlag)
    setIBValuesChangeFlag(false)
    setOBValuesChangeFlag(false)
  }
  const handleTableChange = pagina => {
    const params = {
      ...pagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setPagination({ ...params })
    setQueryFlag(!queryFlag)
  }
  const getParams = () => {
    const info = (formRef.current && formRef.current.getSearchValue()) || {}
    const infoIb = (formRefIB.current && formRefIB.current.getSearchValue()) || {}
    const infoOb = (formRefOB.current && formRefOB.current.getSearchValue()) || {}
    const { scanDate } = info
    const { ibGrDate } = infoIb
    const { obGiDate } = infoOb
    const params = {
      ...info,
      ...infoIb,
      ...infoOb,
      epc: info.epc,
      startScanTime: formatStartTime(scanDate),
      endScanTime: formatEndTime(scanDate),
      startGiDate: formatStartTime(obGiDate),
      endGiDate: formatEndTime(obGiDate),
      startGrDate: formatStartTime(ibGrDate),
      endGrDate: formatEndTime(ibGrDate)
    }
    delete params.scanDate
    delete params.ibGrDate
    delete params.obGiDate
    return params
  }
  const searchDataFun = () => {
    const params = {
      ...getParams(),
      size: pagination.pageSize,
      pageNo: pagination.currentPage
    }
    getAccuracyDetailQuery(params).then(res => {
      const dt = res.resultData
      setTableList(dt.records)
      const pg = {
        ...pagination,
        total: dt.total
      }
      setPagination(pg)
    })
  }

  const downLoadFun = () => {
    const params = {
      ...getParams(),
      ...isChineseFun()
    }
    exportAccuracyDetailPage(params).then(res => {
      downLoadFileBlob(res)
    })
  }

  const onChangeCollapse = (e, type) => {
    if (type === 'IB') {
      let isCollapse = false
      if (e.length > 0) {
        isCollapse = false
        // formRefIB.current && formRefIB.current.setValue(formRefIBValues.current || {})
      } else {
        isCollapse = true
        // let info = (formRefIB.current && formRefIB.current.getSearchValue()) || {}
        // formRefIBValues.current = info
      }
      setIBValuesChangeFlag(isCollapse && hasValuesChange(type))
    } else {
      let isCollapse = false
      if (e.length > 0) {
        isCollapse = false
      } else {
        isCollapse = true
      }
      setOBValuesChangeFlag(isCollapse && hasValuesChange(type))
    }
  }
  const hasValuesChange = type => {
    let defaultValues = {}
    let info = {}
    if (type === 'IB') {
      defaultValues = getInitialValues(ibSearchList)
      info = (formRefIB.current && formRefIB.current.getSearchValue()) || {}
    } else {
      defaultValues = getInitialValues(obSearchList)
      info = (formRefOB.current && formRefOB.current.getSearchValue()) || {}
    }
    let defalutStringify = JSON.stringify(defaultValues)
    let infoStringify = JSON.stringify(info)
    if (infoStringify === '{}' || defalutStringify === infoStringify) {
      return false
    } else {
      return true
    }
  }
  return (
    <div>
      <Card bordered={false} bodyStyle={{ padding: 4 }}>
        <div className="search-bar">
          <SearchBar
            ref={formRef}
            searchList={[...searchList]}
            // showSearchBtn={true}
            // showClearBtn={true}
            // onSearch={searchDataBtn}
            // onClear={searchClearDataBtn}
          />
          <Collapse
            className="mt8"
            size="small"
            onChange={e => {
              onChangeCollapse(e, 'IB')
            }}
            expandIcon={({ isActive }) => (
              <div className={iBValuesChangeFlag ? 'activeChange' : 'defaultChange'}>
                <CaretRightOutlined rotate={isActive ? 90 : 0} />
              </div>
            )}
            items={[
              {
                key: 'IB',
                label: (
                  <div className={iBValuesChangeFlag ? 'activeChange' : 'defaultChange'}>
                    {formatMessageNew('languageObj.operationAccuracyDetail.IBTitle') +
                      formatMessageNew('languageObj.operationAccuracyDetail.filter')}
                  </div>
                ),
                children: (
                  <>
                    <SearchBar ref={formRefIB} searchList={[...ibSearchList]} />
                  </>
                )
              }
            ]}
          />
          <Collapse
            className="mt8"
            size="small"
            onChange={e => {
              onChangeCollapse(e, 'OB')
            }}
            expandIcon={({ isActive }) => (
              <div className={oBValuesChangeFlag ? 'activeChange' : 'defaultChange'}>
                <CaretRightOutlined rotate={isActive ? 90 : 0} />
              </div>
            )}
            items={[
              {
                key: 'OB',
                label: (
                  <div className={oBValuesChangeFlag ? 'activeChange' : 'defaultChange'}>
                    {formatMessageNew('languageObj.operationAccuracyDetail.OBTitle') +
                      formatMessageNew('languageObj.operationAccuracyDetail.filter')}
                  </div>
                ),
                children: (
                  <>
                    <SearchBar ref={formRefOB} searchList={[...obSearchList]} />
                  </>
                )
              }
            ]}
          />
          <div className="mt8">
            <SearchBar
              searchList={[]}
              showSearchBtn={true}
              showClearBtn={true}
              onSearch={searchDataBtn}
              onClear={searchClearDataBtn}
            />
          </div>
        </div>
        <div className="content-container overflow_visible mt20">
          <AntdTable
            rowKey={(record, index) => record.id || index}
            dataSource={tableList}
            columns={tableColumns}
            // 独一无二的标识，不能重复
            columnsKey="columns_accuracyDetail"
            onDownload={downLoadFun}
            pagination={pagination}
            onChange={handleTableChange}
          />
        </div>
      </Card>
    </div>
  )
}
export default OperationAccuracyDetail
